import { BreakpointState } from '@angular/cdk/layout';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { GroupType } from 'src/app/core/enums/enums';
import { Currency } from 'src/app/core/models/Common';
import { FileResponse } from 'src/app/core/models/File';
import { IRole, IUser, UserStore } from 'src/app/core/models/User';
import {
  AuthentificationService,
  CurrencyService,
  FileService,
  UserService,
} from 'src/app/core/rest-services/rest-services';
import { NotificationService } from 'src/app/core/services/notification.service';
import {
  BreakpointMatcherService,
  PhoneNumberService,
  ServicesService,
  SessionService,
} from 'src/app/core/services/services';
import { INPUT_CLASSES } from 'src/app/core/utils/constant';
import { isEmptyString, isValidPhoneNumber } from 'src/app/core/utils/core';
import { getCountries } from 'src/app/core/utils/country';
import { makeCurrencytoShow } from 'src/app/core/utils/functions';
import { noop, shortenFileName } from 'src/app/core/utils/misc';
import { Country, OptionObject, Phone } from 'src/app/core/utils/type';
import { DiscountComponent } from 'src/app/shared-components/discount/discount.component';
import { MaterialConfirmDialogComponent } from 'src/app/shared-components/material-confirm-dialog/material-confirm-dialog.component';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent implements OnInit {
  isEditing: boolean = false;
  isModalDeleteAccountOpen: boolean = false;
  public user!: IUser;
  currency!: Currency;
  pickCountryValue?: OptionObject;
  isDeleting = false;
  currencyOptions!: OptionObject[];
  genderOptions: OptionObject[] = [
    {
      label: 'M',
      value: this.translateService.instant('common.gender-male'),
    },
    {
      label: 'F',
      value: this.translateService.instant('common.gender-female'),
    },
    {
      label: 'O',
      value: this.translateService.instant('common.gender-other'),
    },
  ];
  selectedCurrencie?: OptionObject;
  selectedGender: OptionObject = {
    label: 'M',
    value: this.translateService.instant('common.gender-male'),
  };

  form!: FormGroup;

  isLoading: boolean = false;
  isError: boolean = false;
  isSuccess: boolean = false;
  isTransitioning = false;
  currencies: Currency[] = [];
  userExpected?: UserStore;
  imageName?: string;
  phoneModel: Phone = {};
  input_cls = INPUT_CLASSES;
  emailPattern = '^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$';
  file?: File;
  hasWhatapp = false;
  tel: any;
  displayableFileName?: string;
  breackpointMatche = false;
  country = '';
  isPushNActivated = false;
  currentRole!: IRole;
  groupType = GroupType;
  currentTab = '_TAB_P_INFOS';
  langaugeSettingsIsOpen = false;

  constructor(
    public breakpointMatcherService: BreakpointMatcherService,
    public dialogRef: MatDialogRef<ProfileComponent>,
    public authService: AuthentificationService,
    private fb: FormBuilder,
    private currencyService: CurrencyService,
    private userService: UserService,
    private translateService: TranslateService,
    private notificationService: NotificationService,
    private sessionService: SessionService,
    private services: ServicesService,
    private fileService: FileService,
    private phoneNumberService: PhoneNumberService,
  ) {
    this.currentRole = this.sessionService.getCurrentRole();
  }

  ngOnInit(): void {
    this.user = this.sessionService.getUser();
    this.currency = this.sessionService.getCurrencie();
    this.selectedCurrencie = {
      label: String(this.currency.id),
      value: `${this.currency.code} (${this.currency.symbol})`,
    };
    this.form = this.fb.group({
      firstName: [''],
      lastName: [''],
      email: ['', Validators.pattern(this.emailPattern)],
    });
    this.fetchCurrencies();
    this.patchForm();
    this.breakpointMatcherService.initObserver('md').subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.breackpointMatche = true;
      } else {
        this.breackpointMatche = false;
      }
    });
    this.isPushNActivated = !!this.sessionService.getPushN();
  }

  patchForm(): void {
    this.form.patchValue({
      firstName: this.user.data ? this.user.data.firstName : '',
      lastName: this.user.data ? this.user.data.lastName : '',
      email: this.user.email,
    });
    this.hasWhatapp = this.user.has_whatsapp === 0 ? false : true;
    if (!this.user.tel) this.country = this.sessionService.getCountry().country;
    this.tel = this.user.tel ? this.user.tel : '';
    this.phoneModel.hasWhatsapp = this.user.has_whatsapp === 0 ? false : true;
    this.selectedGender = {
      label: this.user.gender === 'M' ? 'M' : this.user.gender === 'F' ? 'F' : 'O',
      value:
        this.user.gender === 'M'
          ? this.translateService.instant('common.gender-male')
          : this.user.gender === 'F'
          ? this.translateService.instant('common.gender-female')
          : this.translateService.instant('common.gender-other'),
    };
    this.selectedCurrencie = {
      label: String(this.currency.id),
      value: `${this.currency.code} (${this.currency.symbol})`,
    };
    let code = '';
    if (this.user.data?.country) {
      let countries: Country[] = getCountries({ longList: true });
      let country = countries.find((country) => country.name === this.user.data?.country)!;
      code = country?.code ?? '';
    }
    this.pickCountryValue = {
      label: code,
      value: this.user.data?.country ?? '',
    };
  }

  get f() {
    return this.form.controls;
  }

  fetchCurrencies(): void {
    this.isTransitioning = true;
    this.currencyService.index().subscribe({
      next: (res: Currency[]) => {
        this.currencies = res;
        this.currencies && this.initCurrenciesFilter();
      },
      error: (error: any) => {
        console.log('Could not get currencies');
      },
      complete: () => {
        this.isTransitioning = false;
      },
    });
  }

  public location(): void {
    this.authService.getlocation().subscribe({
      next: (res: any) => {
        this.country = res.country;
      },
      error: (err: any) => {
        this.isLoading = false;
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }

  handleUploadComponentChanges(event: any): void {
    if (event === 'edit') {
      noop();
    } else if (event === 'delete') {
      this.imageName = undefined;
      this.file = undefined;
      this.displayableFileName = undefined;
    }
  }

  handlePhoneEvent(phone: Phone): void {
    this.phoneModel = phone;
  }

  countryListToOptionObject(): OptionObject[] {
    let countryOptions: OptionObject[] = [];
    let countries: Country[] = getCountries({ longList: true });
    countries.forEach((country) => {
      countryOptions.push({
        label: country.code,
        value: country.name,
      });
    });
    return countryOptions;
  }

  handleSubmit(): void {
    this.isTransitioning = true;
    this.isLoading = true;
    if (!isEmptyString(this.user.email) && !isEmptyString(this.form.value.email)) {
      this.updateProfil();
    } else {
      if (this.phoneModel == null || this.phoneModel == undefined) return;
      if (this.phoneModel?.option !== null || this.phoneModel?.option !== undefined) {
        if (
          this.phoneModel?.phone !== null ||
          (this.phoneModel?.phone !== undefined && isValidPhoneNumber(this.phoneModel?.phone))
        ) {
          this.updateProfil();
        }
      }
    }
  }

  editProfilePicture() {
    if (this.file != undefined && this.file != null) {
      this.isTransitioning = true;
      this.fileService.update(this.user.image_profil.id, this.file).subscribe({
        next: (fileRes: FileResponse) => {
          this.getUser();
          this.notificationService.success(
            this.translateService.instant('kimbo-profile.profile-saved-notification-content'),
          );
        },
        error: (error) => {
          this.isLoading = false;
          this.imageName = undefined;
          this.isTransitioning = false;
        },
        complete: () => {
          this.isLoading = false;
          this.isTransitioning = false;
        },
      });
    }
  }

  updateProfil(): void {
    if (this.selectedCurrencie !== null || this.selectedCurrencie !== undefined) {
      this.userExpected = this.initExpectedUser(this.form.value);
      this.userService.update(this.user.id, this.userExpected).subscribe({
        next: (res: IUser) => {
          this.getUser();
          this.notificationService.success(
            this.translateService.instant('kimbo-profile.profile-saved-notification-content'),
          );
        },
        error: (error: any) => {
          this.notificationService.danger(this.translateService.instant(error.translate));
          this.imageName = undefined;
          this.isLoading = false;
          this.isTransitioning = false;
        },
        complete: () => {
          this.isLoading = false;
          this.isTransitioning = false;
        },
      });
    }
  }

  _isValidPhoneNumber(tel: string): boolean {
    if (tel) return isValidPhoneNumber(tel);
    else return false;
  }

  getUser(): void {
    this.isTransitioning = true;
    this.userService.view(this.user.id).subscribe({
      next: (userRes: IUser) => {
        this.user = userRes;
        this.sessionService.deleteUser();
        this.sessionService.storeUser(userRes);
        this.fetchCurrencie(userRes);
      },
      error: (err: any) => {
        console.log(err);
        this.isTransitioning = false;
      },
      complete: () => {
        this.isTransitioning = false;
      },
    });
  }

  fetchCurrencie(userRes: IUser): void {
    this.isTransitioning = true;
    this.currencyService.view(userRes.currencie_id).subscribe({
      next: (res: Currency) => {
        this.sessionService.deleteUserCurrencie();
        this.sessionService.storeUserCurrencie(res);
        this.sessionService.deleteCurrencie();
        this.sessionService.storeCurrencie(res);
        this.services.eventService.publish('user:update', userRes);
      },
      error: (error) => {},
      complete: () => {
        this.isTransitioning = false;
      },
    });
  }

  initExpectedUser(formValue: any): UserStore {
    const phone = this.phoneModel != null ? this.phoneModel.phone?.trim() : this.user.tel;
    const hasWhatsapp = this.phoneModel?.hasWhatsapp ?? this.user?.has_whatsapp;
    let data: any = {
      ...formValue,
      country:
        this.phoneModel.option &&
        this.phoneModel.phone &&
        (this.pickCountryValue?.label === 'DZ' || this.pickCountryValue?.label === 'AF')
          ? this.phoneModel.option.value
          : this.pickCountryValue?.value
          ? this.pickCountryValue?.value
          : this.user.data?.country
          ? this.user.data?.country
          : null,
    };
    let userStore: UserStore = new UserStore(
      formValue.email,
      phone ?? '',
      this.selectedGender.label,
      Intl.DateTimeFormat().resolvedOptions().timeZone,
      data,
      Number(this.selectedCurrencie?.label),
      undefined,
      hasWhatsapp ? 1 : 0,
    );
    return userStore;
  }

  initCurrenciesFilter(): void {
    this.currencyOptions = [];
    this.currencies.forEach((currencie) => {
      this.currencyOptions.push({
        label: String(currencie.id),
        value: `${this.convertXafXof(currencie.code)} (${currencie.symbol})`,
      });
    });
  }

  handleDelete(): void {
    this.isLoading = true;
    this.userService.delete(this.user.id).subscribe({
      next: (res: IUser) => {
        this.logout();
      },
      error: (error: any) => {
        this.translateService.instant('common.line-deleted-error');
        this.isLoading = false;
      },
      complete: () => {
        this.isLoading = false;
        this.isTransitioning = false;
      },
    });
  }

  handleCurrencyDropdownEvent(currency: OptionObject): void {
    this.selectedCurrencie = currency;
  }

  handleGenderDropdownEvent(gender: OptionObject): void {
    this.selectedGender = gender;
  }

  _formatPhoneNumber(phoneNumber: string): string {
    return this.phoneNumberService.formatPhoneNumber(phoneNumber);
  }

  logout(): void {
    this.dialogRef.close();
    this.authService.logout().subscribe({
      next: (value: any) => {
        this.sessionService.logout();
      },
    });
  }

  setIsEditing(): void {
    this.isEditing = this.isEditing ? false : true;
  }

  close(): void {
    this.dialogRef.close();
  }

  openDeleteAccountDialog(): void {
    this.services.modalService
      .openModal(MaterialConfirmDialogComponent, {
        width: '500px',
        height: 'auto',
      })
      .subscribe((action) => {
        if (action === '_YES') {
          this.handleDelete();
        }
      });
  }

  handleCountryDropdownEvent(option: any): void {
    if (option !== 'open') {
      //option.value = this.translateService.instant('common.' + option.label.toLowerCase());
      this.pickCountryValue = option;
    }
  }

  countryListToOptionObjectCountry(): OptionObject[] {
    let countryOptions: OptionObject[] = [];
    let countries: Country[] = getCountries({ longList: true });
    countries.forEach((country) => {
      countryOptions.push({
        label: country.code,
        value: country.name,
      });
    });
    return countryOptions;
  }

  togglePushN(): void {
    if (this.currentRole.group.type === this.groupType.Kimbo) {
      this.isPushNActivated = !this.isPushNActivated;
      this.isPushNActivated ? this.sessionService.storePushN() : this.sessionService.deletePushN();
    }
  }

  openDiscountModal(): void {
    this.services.modalService
      .openModal(DiscountComponent, {
        width: '400px',
        height: 'auto',
      })
      .subscribe((action) => {});
  }

  convertXafXof(currency: string) {
    return makeCurrencytoShow(currency);
  }

  handleTabClick(tab: string): void {
    this.currentTab = tab;
  }

  shortenFileName(longName: string): string {
    return shortenFileName(longName);
  }

  handleAvatarEvents(event: any): void {
    this.imageName = undefined;
    setTimeout(() => {
      this.imageName = event.url;
      this.file = event.file;
      this.editProfilePicture();
    }, 1000);
  }
}
